import React from 'react';
import '../../styles/sections.css';
import '../../styles/challenges.css';

const Challenges = () => {
  return (
          <section className="challenges-section">
        <div className="section-header">
          <h2>CHALLENGES</h2>
          <div className="underline"></div>
        </div>
        <div className="challenges-content">
        <ul>
          <li>Collaborating in a large development team while maintaining separation of concerns and minimizing merge conflicts.</li>
          <li>Managing complex Git workflows across multiple branches and ensuring clean merges without overwriting critical changes.</li>
          <li>Integrating third-party APIs like YouTube securely and handling inconsistent response formats across endpoints.</li>
          <li>Ensuring authentication security with hashed passwords, token expiration, and role-based access across user types.</li>
          <li>Coordinating consistent UI/UX behavior across ASP.NET backend views while maintaining a responsive front-end experience.</li>
          <li>Debugging asynchronous behavior in playlist creation and playback flow, especially when user actions were chained together.</li>
          <li>Handling edge cases such as users liking content without authentication, or accessing expired media links.</li>
        </ul>
      </div>
    </section>
  );
};

export default Challenges;
